import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Contract } from "@/types/contract";

interface CorporateNotesProps {
  contract: Contract;
}

export function CorporateNotes({ contract }: CorporateNotesProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Corporate Investor Notes</CardTitle>
      </CardHeader>
      <CardContent>
        {contract.notes ? (
          <p className="whitespace-pre-line">{contract.notes}</p>
        ) : (
          <p className="text-muted-foreground italic">No additional notes available.</p>
        )}
      </CardContent>
    </Card>
  );
}